import { render, staticRenderFns } from "./TgBlockedStatus.vue?vue&type=template&id=003abfd5"
import script from "./TgBlockedStatus.vue?vue&type=script&lang=js"
export * from "./TgBlockedStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports